import API from '@/api/base'

const state = {
  // = data
  all: [],
}

const getters = {}

const actions = {
  // = Methods
  submitContact: (event, params) =>
    new Promise((resolve, reject) => {
      API.post(`roaringsky/contact`, params)
        .then(response => {
          resolve(response.msg)
        })
        .catch(error => {
          reject(error)
        })
    }),
}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations,
}
